import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { studentAPI } from '@/lib/api';
import AppShell from '@/components/AppShell';
import StudentMediaLibrary from '@/components/student/StudentMediaLibrary';
import PendingTransferAlert from '@/components/PendingTransferAlert';
import { ArrowLeft } from 'lucide-react';

const StudentMyMusic = () => {
  const { student, studentLogout } = useAuth();
  const navigate = useNavigate();

  const { data: studentData } = useQuery({
    queryKey: ['student-detail', student?.id],
    queryFn: async () => (await studentAPI.getById(student.id)).data,
    enabled: !!student?.id,
  });

  if (!student) return null;

  return (
    <AppShell title="My Music & Media" subtitle={`${studentData?.full_name || student.full_name}'s Library`}
      onLogout={() => { studentLogout(); navigate('/student-login'); }}
      isStudent={true} studentId={student?.id}
      rightContent={
        <button onClick={() => navigate('/academy')}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-bold transition-all hover:scale-105"
          style={{ background: 'rgba(255,255,255,0.08)', color: '#94A3B8', border: '1px solid rgba(255,255,255,0.1)' }}>
          <ArrowLeft size={14} /> Back to Academy
        </button>
      }>
      <div className="max-w-4xl mx-auto">
        <PendingTransferAlert />
        <StudentMediaLibrary student={studentData || student} />
      </div>
    </AppShell>
  );
};

export default StudentMyMusic;
